import { createStore } from 'vuex'

export default createStore({
  state: {
    // categories: ["Запчасти и комплектующие","Центр сертификаций и испытаний","Промышленная автоматизация","Обслуживание и сервис"],
    // categories: ["ЗИП, Оборудование, Трейдинг", "Центр сертификаций и испытаний", "Промышленная автоматизация (АСУ ТП и КИП)", "Обслуживание и сервис", "ЗРА, включая центр проектирования и испытаний"],
    categories: [],
    categories_checked:[],
    
    // categories: [],
    sum_fact: "",
    sum_plan: "",

    year_change: 2026,

    metric_filtr: [],
    arr_metric: ['Контракты', 'Количество РЦ', 'Количество моделей нового оборудования и их цифровые двойники', 'Инспекции МТР'],
  //   metric_filtr: [{"claster":"ЗИП, Оборудование, Трейдинг", "claster_id":1, "block":"Контракты", "block_id":2, "pokazatel":['Контракты', 'Количество РЦ', 'Количество моделей нового оборудования и их цифровые двойники'], "pokazatel_cheked":[]},
  

  //   {"claster":"ЗИП, Оборудование, Трейдинг", "claster_id":1, "block":"Новое оборудование", "block_id":4, "pokazatel":['Количество моделей нового оборудования и их цифровые двойники', 'Контракты'], "pokazatel_cheked":[]},

  //   {"claster":"Центр сертификаций и испытаний", "claster_id":2, "block":"Инспекции, оценка соответствий", "block_id":7, "pokazatel":['Инспекции МТР', 'Оценка соответствия', 'Контракты'], "pokazatel_cheked":[]}

  
  // ],
    // metric_filtr_check_box: ['Контракты'],
    metric_filtr_check_box: [],
  //   metric_filtr_check_box: [
  //   {"claster":'ЗИП, Оборудование, Трейдинг',"claster_id":1,'block_id':2,"pokazatel":['Контракты']},
  //   {"claster":'ЗИП, Оборудование, Трейдинг',"claster_id":1,'block_id':3,"pokazatel":['Количество РЦ']},
  //   {"claster":'ЗИП, Оборудование, Трейдинг',"claster_id":1,'block_id':4,"pokazatel":['Количество моделей нового оборудования и их цифровые двойники']},
  //   {"claster":'',"claster_id":2,'block_id':7,"pokazatel":['Инспекции МТР']},
  //   {"claster":'',"claster_id":2,'block_id':9,"pokazatel":['Испытания']},
  //   {"claster":'',"claster_id":3,'block_id':11,"pokazatel":['Контракты']},
  //   {"claster":'',"claster_id":3,'block_id':12,"pokazatel":['Поставка']},
  //   {"claster":'',"claster_id":4,'block_id':15,"pokazatel":['Контракты']},
  //   {"claster":'',"claster_id":4,'block_id':16,"pokazatel":['Освоение технологий производства']},
  //   {"claster":'',"claster_id":5,'block_id':17,"pokazatel":['Контракты (Наземное, скважинное об-ние)']},
  //   {"claster":'',"claster_id":5,'block_id':18,"pokazatel":['Контракты (Компрессорное, энергетическое об-ние)']},
  //   {"claster":'',"claster_id":6,'block_id':20,"pokazatel":['Контракты']},
  //   {"claster":'',"claster_id":6,'block_id':21,"pokazatel":['Производство']},
  //   {"claster":'',"claster_id":7,'block_id':25,"pokazatel":['Контракты']},
  //   {"claster":'',"claster_id":7,'block_id':23,"pokazatel":['Количество (аренда)']},
  //   {"claster":'',"claster_id":8,'block_id':26,"pokazatel":['Продукты']},
  //   {"claster":'',"claster_id":8,'block_id':27,"pokazatel":['Контракты']},
  // ],
    selectedDate_before: null,
    selectedDate_after: null,

    // конвертированные даты для показа на фронте
    selectedDate_before_converded: null,
    selectedDate_after_converded: null,

    // переключение состояние приложением
    status_check_filtr: false,

    // отфильтрованный список с календаря
    selected_Date_arr: [],

    // Димнамические строки
    posts_test_claster_stroki:[],

  },
  getters: {
    test_func(state){
      return state.sum_fact * 2
    },
  },
  mutations: {
    // Мутация для изменения года
    SET_YEAR(state, newYear) {
      state.year_change = newYear;
    }
  },
  actions: {
      
      
  },
  modules: {
  }
})
